import { useEffect, useState } from 'react'

export const useInertSupport = (): boolean => {
  const [supportsInert, setSupportsInert] = useState(false)

  useEffect(() => {
    const testElement = document.createElement('div')
    testElement.setAttribute('inert', '')
    const hasInert = testElement.hasAttribute('inert')
    setSupportsInert(hasInert)
  }, [])

  return supportsInert
}
